import React from 'react'
import { connect } from 'react-redux'
import get from 'lodash/get'

import { getBestProgramValue, getQuoteValue } from 'selectors/quoteSelectors'
import { getYMMT } from 'selectors/inventorySelectors'
import { getEntity } from 'selectors/entitySelectors'

import './ProgramDetails.scss'

export function ProgramDetails(props) {
  let { mode, ymmt, vin } = props

  return (
    <div className="program-details-wrapper">
      <div className="program-details">
        <p>
          This is an example, not an offer. Actual offers will be made at the
          location upon confirming programs, credit worthiness and vehicle
          availability. While this example should be a fair representation of
          options available, it is not an offer to sell. All applicable fees and
          taxes may not be included in all pricing.
        </p>
        <p>
          Customer must include their correct zip code where they reside for
          accurate sample payment. Dealer is not responsible for consumer
          errors.
        </p>
        {mode !== 'cash' && (
          <p>
            Payments shown require approval with verified credit on a {ymmt}{' '}
            with serial number: {vin}. Please see the Payment Summary for more
            details.
          </p>
        )}
        {mode !== 'cash' && (
          <p>
            Lessees will be financially responsible for mileage beyond the
            elected quantity and for vehicle maintenance and repairs and
            excessive vehicle wear.
          </p>
        )}
        <p>
          MPG estimates on this website are EPA estimates; your actual mileage
          may vary. For used vehicles, MPG estimates are EPA estimates for the
          vehicle when it was new. The EPA periodically modifies its MPG
          calculation methodology; all MPG estimates are based on the
          methodology in effect when the vehicles were new (please see the my
          portion of the EPA website for details, including a MPG recalculation
          tool).
        </p>
        <p>
          Safety ratings are provided by the National Highway Traffic Safety
          Association. Please see{' '}
          <a
            href="https://www.nhtsa.gov/ratings"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.nhtsa.gov/ratings
          </a>{' '}
          for further details.
        </p>
        <p>
          The features and options listed are for a {ymmt} and may not apply to
          this specific vehicle.
        </p>
        <p>
          <strong>For Texas Dealers:</strong> Manufacturer's Rebate or
          Additional Dealer Discounts are subject to residency restrictions. Any
          customer not meeting the residency restrictions will receive a dealer
          discount in the same amount of the manufacturer's rebate.
        </p>
        <p>
          <strong>For Washington State Dealers:</strong> A negotiable $150
          document fee may be added to the sale price.
        </p>
        <p>
          <strong>For Wisconsin Dealers:</strong> Everyone qualifies for applied
          manufacturer rebates. Service fee extra.
        </p>
      </div>
    </div>
  )
}

function mapStateToProps(state, op) {
  let bankCode = getBestProgramValue(
      state,
      op.vehicleId,
      op.quoteId,
      op.mode,
      'Lender',
    ),
    zip = getQuoteValue(state, op.vehicleId, op.quoteId, 'customerZipCode'),
    vehicle = getEntity(state, op.vehicleId)

  return {
    ...op,
    bankCode,
    zip,
    ymmt: getYMMT(state, op.vehicleId),
    vin: get(vehicle, 'vin'),
  }
}

export default connect(mapStateToProps)(ProgramDetails)
